"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pie3D = void 0;
var react_1 = __importStar(require("react"));
var Label_1 = require("./components/Label");
var Path_1 = require("./components/Path");
var const_1 = require("./const");
var utils_1 = require("./utils");
var styles = {
    height: '100%',
    width: '100%'
};
var Pie3D = function (_a) {
    var config = _a.config, data = _a.data;
    var _b = (0, react_1.useState)(0), height = _b[0], setHeight = _b[1];
    var _c = (0, react_1.useState)(0), width = _c[0], setWidth = _c[1];
    var _d = (0, react_1.useState)(0), rx = _d[0], setRx = _d[1];
    var _e = (0, react_1.useState)((0, utils_1.mapData)([])), mappedData = _e[0], setMappedData = _e[1];
    if (!(0, utils_1.checkIsDataArrayOfNumbers)(data)) {
        if (!(0, utils_1.checkIsUserData)(data)) {
            throw new Error('Wrong data format');
        }
    }
    var pieConfig = __assign(__assign({}, const_1.defaultConfig), config);
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        setMappedData((0, utils_1.checkIsDataArrayOfNumbers)(data) ? (0, utils_1.mapData)((0, utils_1.mapRowData)(data)) : (0, utils_1.mapData)(data));
    }, [data]);
    (0, react_1.useEffect)(function () {
        if (ref.current !== null) {
            setHeight(ref.current.clientHeight);
            setWidth(ref.current.clientWidth);
        }
        setRx(height / 2 * pieConfig.size);
    }, [ref.current, pieConfig]);
    if (!Array.isArray(data)) {
        throw new Error('Prop data should be an array');
    }
    var moveElement = function (startAngle) { return setMappedData(mappedData.map(function (element) {
        return element.startAngle === startAngle ? __assign(__assign({}, element), { moved: !element.moved }) : element;
    })); };
    var ry = rx * pieConfig.angle / 90;
    var pathVariables = __assign({ moveElement: moveElement, rx: rx, ry: ry }, pieConfig);
    var _f = (0, utils_1.createElementPieces)(mappedData), p1Elements = _f[0], p2Elements = _f[1], p3Elements = _f[2], p4Elements = _f[3], exceptionElements = _f[4];
    var mappedTopAndLabelElements = mappedData.map(function (item) {
        return react_1.default.createElement("g", { key: item.middleAngle },
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: 'top' }));
    });
    var mappedP1Elements = p1Elements.map(function (item) {
        var _a, _b;
        return (react_1.default.createElement("g", { key: item.middleAngle },
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "start" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "end" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "outer" }),
            (config === null || config === void 0 ? void 0 : config.showLabels) === true && react_1.default.createElement(Label_1.Label, { data: item, pathVariables: pathVariables, chartWidth: width, textSize: (_a = config === null || config === void 0 ? void 0 : config.textSize) !== null && _a !== void 0 ? _a : const_1.defaultConfig.textSize, showLabelPercentage: (_b = config.showLabelPercentage) !== null && _b !== void 0 ? _b : true })));
    });
    var mappedP2Elements = p2Elements
        .sort(function (a, b) { return b.startAngle - a.startAngle; })
        .map(function (item) {
        var _a, _b;
        return (react_1.default.createElement("g", { key: item.middleAngle },
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "end" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "start" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "outer" }),
            (config === null || config === void 0 ? void 0 : config.showLabels) === true && react_1.default.createElement(Label_1.Label, { data: item, pathVariables: pathVariables, chartWidth: width, textSize: (_a = config === null || config === void 0 ? void 0 : config.textSize) !== null && _a !== void 0 ? _a : const_1.defaultConfig.textSize, showLabelPercentage: (_b = config.showLabelPercentage) !== null && _b !== void 0 ? _b : true })));
    });
    var mappedP3Elements = p3Elements
        .sort(function (a, b) { return b.startAngle - a.startAngle; })
        .map(function (item) {
        var _a, _b;
        return (react_1.default.createElement("g", { key: item.middleAngle },
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "end" }),
            item.startAngle > const_1.pi && react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "start" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "inner" }),
            item.startAngle <= const_1.pi && react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "start" }),
            item.startAngle < const_1.pi && react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "outer" }),
            (config === null || config === void 0 ? void 0 : config.showLabels) === true && react_1.default.createElement(Label_1.Label, { data: item, pathVariables: pathVariables, chartWidth: width, textSize: (_a = config === null || config === void 0 ? void 0 : config.textSize) !== null && _a !== void 0 ? _a : const_1.defaultConfig.textSize, showLabelPercentage: (_b = config.showLabelPercentage) !== null && _b !== void 0 ? _b : true })));
    });
    var mappedP4Elements = p4Elements
        .sort(function (a, b) { return a.startAngle - b.startAngle; })
        .map(function (item) {
        var _a, _b;
        return (react_1.default.createElement("g", { key: item.middleAngle },
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "start" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "end" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "inner" }),
            item.startAngle < const_1.pi && react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "outer" }),
            (config === null || config === void 0 ? void 0 : config.showLabels) === true && react_1.default.createElement(Label_1.Label, { data: item, pathVariables: pathVariables, chartWidth: width, textSize: (_a = config === null || config === void 0 ? void 0 : config.textSize) !== null && _a !== void 0 ? _a : const_1.defaultConfig.textSize, showLabelPercentage: (_b = config.showLabelPercentage) !== null && _b !== void 0 ? _b : true })));
    });
    var exception = exceptionElements.map(function (item) {
        var _a, _b;
        return (react_1.default.createElement("g", { key: item.middleAngle },
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "end" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "start" }),
            react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "inner" }),
            item.startAngle < const_1.pi && react_1.default.createElement(Path_1.Path, { data: item, pathVariables: pathVariables, type: "outer" }),
            (config === null || config === void 0 ? void 0 : config.showLabels) === true && react_1.default.createElement(Label_1.Label, { data: item, pathVariables: pathVariables, chartWidth: width, textSize: (_a = config === null || config === void 0 ? void 0 : config.textSize) !== null && _a !== void 0 ? _a : const_1.defaultConfig.textSize, showLabelPercentage: (_b = config.showLabelPercentage) !== null && _b !== void 0 ? _b : true })));
    });
    return (react_1.default.createElement("svg", { ref: ref, style: styles },
        react_1.default.createElement("g", { transform: "translate(".concat(width / 2, ", ").concat(height / 2, ")") },
            exception,
            mappedP4Elements,
            mappedP1Elements,
            mappedP3Elements,
            mappedP2Elements,
            mappedTopAndLabelElements)));
};
exports.Pie3D = Pie3D;
